export default __webpack_public_path__ + "static/media/payment-amex.011cb351.svg";